(function() {
    'use strict';

    angular
        .module('bhsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('data', {
            parent: 'entity',
            url: '/data?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bhsApp.data.home.title'
            },
            views: {
                'content@bhs': {
                    templateUrl: 'app/entities/data/data.html',
                    controller: 'DataController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('data');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('data-detail', {
            parent: 'entity',
            url: '/data/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bhsApp.data.detail.title'
            },
            views: {
                'content@bhs': {
                    templateUrl: 'app/entities/data/data-detail.html',
                    controller: 'DataDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('data');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Data', function($stateParams, Data) {
                    return Data.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'data',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('data-detail.edit', {
            parent: 'data-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/data/data-dialog.html',
                    controller: 'DataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Data', function(Data) {
                            return Data.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('data.new', {
            parent: 'data',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/data/data-dialog.html',
                    controller: 'DataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                tableau: null,
                                colonne: null,
                                effectifHomme: null,
                                effectifFemme: null,
                                nbAccidentsSansArret: null,
                                nbAccidentsAvecArret: null,
                                effectif: null,
                                nbJourneesPerdues: null,
                                effectifCadre: null,
                                effectifNonCadre: null,
                                nbMaladiesProDeclarees: null,
                                nbHeuresTravaillees: null,
                                nbCHS: null,
                                nbRepresentantPersonnel: null,
                                nbReuCHS: null,
                                nbReuCHRS: null,
                                nbAvisDefavorables: null,
                                nbExercicesSecurite: null,
                                nbExercicesSurete: null,
                                nbSurvMedicale: null,
                                nbVisitesMedecine: null,
                                depensesEngagees: null,
                                cotisationsVersees: null,
                                tauxAT: null,
                                initiatives: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('data', null, { reload: 'data' });
                }, function() {
                    $state.go('data');
                });
            }]
        })
        .state('data.edit', {
            parent: 'data',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/data/data-dialog.html',
                    controller: 'DataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Data', function(Data) {
                            return Data.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('data', null, { reload: 'data' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('data.delete', {
            parent: 'data',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/data/data-delete-dialog.html',
                    controller: 'DataDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Data', function(Data) {
                            return Data.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('data', null, { reload: 'data' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
